import React from "react";
import { Redirect } from 'react-router-dom';
import CardGrid from "../components/CardGrid";
import CanvasJSChartContainer from '../components/CanvasJSChartContainer';
//import { CanvasJS } from "../lib/canvasjs.react";
import {
    getMonthsForLast2Years,
    isEmpty,
    //removeSpaces,
    formatMoney
} from "../helpers";
import {
    inventoryDataPointColorSet,
    profitDataPointColorSet,
    salesByProductGroupColorSet,
    chartLineColor,
    chartFontFamily,
    chartLabelFontSize,
    chartFontColor,
    chartTitleStyleParams,
    commonChartProps,
    isEmptyDataset,
    emptyDataset
} from "../components/utils/ChartHelpers";
import DashboardFilters from '../components/DashboardFilters';
import Header from "../components/Header";
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';

import isPage from "../hoc/isPage";
import { AppContext } from "../context/AppContext";
//import moment from "moment";
import { Exception } from "handlebars";

const qs = require("query-string");

//var CanvasJSReact = require("../lib/canvasjs.react");
//var CanvasJS = CanvasJSReact.CanvasJS;


class Dashboard extends React.Component {


    //constructor(props) {
    //    super(props);
    //}

    state = {
        dates: [], // list of pickable dates

        kpiData: null, // data for the cards
        inventoryData: null, // data for the stacked horitzontals
        ytdProfitData: null, // data for the pareto chart
        productSalesData: null, // data for donut graph

        drillUrl: null // if this is set, this means we are going to drill down to another URL
    };

    componentDidMount() {

        let { orgType, childDealerships, reportGroups } = this.context.state;

        // if user is a dealer group or higher org type,
        // AND we don't have the list of dealers or report groups loaded yet,
        // then we need to load up the list of dealerships and report groups
        if (
            orgType !== "dealer" &&
            (isEmpty(childDealerships) ||
                isEmpty(reportGroups))
        ) {
            // we need to get the list of dealers and report groups under the current org
            const dealersPromise = this.props.getData("/api/portal/dealer/GetList");
            const reportGroupsPromise = this.props.getData("/api/portal/reportGroup/GetList?includeOrgsList=1");
            Promise.all([dealersPromise, reportGroupsPromise]).then(([dealers, reportGroups]) => {


                this.context.setState({
                    childDealerships: dealers.data,
                    reportGroups: reportGroups.data
                });
            });
        }

        // get a list of month/year listings for the past two years
        const datepickerDates = getMonthsForLast2Years(this.props.getLanguage());
        this.setState({
            dates: datepickerDates
        });

        // try to see if there is a previously selected month/year; if not, then just grab the current month/year
        // afterwards, run the dashboard filtering
        let selectedFilterDate = this.context.state.selectedFilterDate;
        if (!selectedFilterDate) {
            this.context.setState({ selectedFilterDate: datepickerDates[datepickerDates.length - 1] }, () => {
                this.applyDashboardFilters();
            });
        } else {
            this.applyDashboardFilters();
        }


    }

    // construct the querystring that will contain all the selected filter values
    // (monthYear, dealership, report group)
    // this querystring will be appended to each of the API calls
    getApiQueryString = () => {
        const { orgType, selectedFilterDate, selectedFilterVendor, selectedFilterType, selectedFilterOrg, selectedFilterReportGroup } = this.context.state;
        const params = {}

        if (selectedFilterDate) {
            params.monthYear = selectedFilterDate.dateID

        }

        if (selectedFilterVendor) {
            if (selectedFilterVendor.vendorID > 0)
                params.vendorID = selectedFilterVendor.vendorID
        }

        // dealership doesn't have option of choosing between dealership or report group
        if (orgType !== "dealer") {
            switch (selectedFilterType) {
                case "dealership":
                    if (!isEmpty(selectedFilterOrg)) {
                        if (selectedFilterOrg.orgID > 0)
                            params.orgID = selectedFilterOrg.orgID
                    }
                    break;
                case "reportGroup":
                    if (!isEmpty(selectedFilterReportGroup)) {
                        if (!isEmpty(selectedFilterReportGroup.reportGroupID))
                            params.reportGroupID = selectedFilterReportGroup.reportGroupID
                    }
                    break;
                default:
                    break;
            }
        }

        //console.log('querystringer', params, Object.keys(params))
        //debugger;
        return ((Object.keys(params).length > 0) ? '?' : '') + qs.stringify(params);
    };

    attachDrilldownLinks = (data) => {

        const params = {};
        const { selectedFilterType: filterType, selectedFilterOrg: org, selectedFilterReportGroup: reportGroup, selectedFilterVendor: vendor } = this.context.state;
        if (filterType === "dealership" && org) {
            if (org.orgID > 0)
                params.orgID = org.orgID;
        }
        else if (filterType === "reportGroup" && reportGroup) {
            if (!isEmpty(reportGroup.reportGroupID))
                params.reportGroupID = reportGroup.reportGroupID;
        }
        // only pass in vendorID if not a manufacturer user
        //if (['dealer', 'dealergroup'].includes(this.context.state.orgType) && vendor) {
        //    if (vendor.vendorID > 0)
        //        params.vendorID = vendor.vendorID;
        //}
        if (vendor) {
            if (vendor.vendorID > 0)
                params.vendorID = vendor.vendorID;
        }

        data.forEach(kpi => {
            if (kpi.metric === "Obsolete Inventory") {
                kpi.link = `/reports/slow-moving-items?reportTitle=Obsolete Inventory&autoFilterType=obsoleteinventory&previousPageUrl=/dashboard&previousPageTitle=Dashboard&${qs.stringify(params)}`;
            } else if (kpi.metric === "Aged Inventory") {
                kpi.link = `/reports/slow-moving-items?reportTitle=Aged Inventory&autoFilterType=agedinventory&previousPageUrl=/dashboard&previousPageTitle=Dashboard&${qs.stringify(params)}`;
            }
        });

    }

    // click the Apply button next to the filters
    applyDashboardFilters = () => {
        const queryString = this.getApiQueryString();

        // get inventory mix by turnover rate
        const urlSummaryApi = `/api/portal/kpi/GetSummary${queryString}`;
        const urlInventoryMixApi = `/api/portal/kpi/GetInventoryMixByTurnoverRate${queryString}`;
        const urlYtdProfitComparisonApi = `/api/portal/kpi/GetYTDProfitComparison${queryString}`;
        const urlSalesByProductApi = `/api/portal/kpi/GetSalesByProductGroup${queryString}`;
        //console.log('urlSummaryApi', urlSummaryApi);
        if (!this.context.state.selectedFilterDate) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0128"));
            return;
        }

        // get KPI summary data

        const summaryDataCall = (this.props
            .getData(urlSummaryApi));

        const inventoryDataCall = (this.props
            .getData(urlInventoryMixApi));

        const ytdProfitComparisonCall = this.props
            .getData(urlYtdProfitComparisonApi);

        const salesByProductCall = this.props
            .getData(urlSalesByProductApi);


        // what do i want here? 
        // wait till i have all the data back before I call setState. 
        // if any of the api calls fail, that's ok, i still want to show the data for the calls that did work.

        let dataCalls = [summaryDataCall, inventoryDataCall, ytdProfitComparisonCall, salesByProductCall]


        Promise.all(dataCalls.map(p => p.catch(e => e))).then(results => {
            // console.log('response', results);
            // console.log('instanceof exception', results[1] instanceof Exception)
            // debugger;

            let kpiData;
            if (results[0] instanceof Exception || results[0] instanceof Error) {
                kpiData = null;
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0129"));
            } else {
                kpiData = results[0].data;
                //if (!isEmpty(kpiData)) {
                //    this.attachDrilldownLinks(kpiData);
                //}
            }

            let inventoryData;
            if (results[1] instanceof Error) {
                inventoryData = emptyDataset;
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0130"));
            } else {
                inventoryData = results[1].data;
            }

            let ytdProfitData;
            if (results[2] instanceof Error) {
                ytdProfitData = emptyDataset;
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0131"));
            } else {
                ytdProfitData = results[2].data
            }

            let productSalesData;
            if (results[3] instanceof Error) {
                productSalesData = emptyDataset;
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0132"));
            } else {
                productSalesData = results[3].data;
            }

            this.setState({
                kpiData, inventoryData, ytdProfitData, productSalesData
            });
        }).catch(error => {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0133"));
        });


    };

    // check if all the required filter parameters have been specified
    parseCategory(category) {
        switch (category) {
        case "Aged Inventory":
            return  "m0535";
        case "Obsolete":
            return  "m0536";
        case "Slow Moving":
            return  "m0537";
        case "Average Moving":
            return  "m0538";
        case "Fast Moving":
            return  "m0539";
        case "P&A":
            return  "m0437";
        case "GM":
            return  "m0436";
        default:
            return  category;
        }
    };
    
    parseSeriesName(name) {
        if (name) {
            var ret = name.replace("Profit", this.props.returnLocalizedString("m0540"));
            return ret.replace("Growth", this.props.returnLocalizedString("m0544"));
        }
        else
            return "";
    }

    // doughnut chart
    getSalesByProductGroupChartParams = () => {
        const { currencyCode } = this.context.state;
        const languageCode = this.props.uiLanguage;
        let points = [];
        if (
            this.state.productSalesData &&
            Object.keys(this.state.productSalesData).length > 0
        ) {
            this.state.productSalesData.data.forEach((point, index) => {

                points.push({
                    y: point.percentValue,
                    indexLabel: this.props.returnLocalizedString(this.parseCategory(point.category)),
                    legendText: this.props.returnLocalizedString(this.parseCategory(point.category)),
                    toolTipContent: `<span style='"'color: {color};'"'>{indexLabel}</span> : ${point.percentValue}% (${formatMoney(point.dollarValue, currencyCode, languageCode)})`,
                    color: salesByProductGroupColorSet[index]
                });
            });
        }

        let data = [
            {
                type: "doughnut",
                showInLegend: true,
                yValueFormatString: "####.00'%'",
                dataPoints: points,
                indexLabelFontFamily: chartFontFamily,
                indexLabelFontSize: chartLabelFontSize,
                indexLabelFontWeight: 500,
                indexLabelFontColor: chartFontColor
                //toolTipContent:
                //    "<span style='\"'color: {color};'\"'>{indexLabel}</span> : {y}"
            }
        ];

        return {
            data: data,
            theme: "light2",
            ...commonChartProps,
            title: {
                text: this.props.returnLocalizedString("m0001"),
                ...chartTitleStyleParams
            }
        };
    };

    // stacked horizontals

    getInventoryChartParams = () => {
        let data = [];
        const { currencyCode } = this.context.state;
        const languageCode = this.props.uiLanguage;

        if (!isEmptyDataset(this.state.inventoryData)) {

            let inventoryData = JSON.parse(
                JSON.stringify(this.state.inventoryData)
            );
            


            inventoryData.dataSeriesLabel.forEach((series, index) => {
                //const dataSeriesName = removeSpaces(series.category.toLowerCase());

                //let drillUrl = '';

                const params = {};
                const { selectedFilterType: filterType, selectedFilterOrg: org, selectedFilterReportGroup: reportGroup, selectedFilterVendor: vendor } = this.context.state;
                if (filterType === "dealership" && org) {
                    if (org.orgID > 0)
                        params.orgID = org.orgID;
                }
                else if (filterType === "reportGroup" && reportGroup) {
                    if (!isEmpty(reportGroup.reportGroupID))
                        params.reportGroupID = reportGroup.reportGroupID;
                }
                // only pass in vendorID if not a manufacturer user
                //if (['dealer', 'dealergroup'].includes(this.context.state.orgType) && vendor) {
                //    if (vendor.vendorID > 0)
                //        params.vendorID = vendor.vendorID;
                //}
                if (vendor) {
                    if (vendor.vendorID > 0)
                        params.vendorID = vendor.vendorID;
                }

                // find all the objects in inventoryData.data where category = series.category
                var results = inventoryData.data.filter(
                    point => point.category === series.category
                );
                results.forEach(result => {
                    result.label = result.year;
                    result.y = result.percentValue;

                    //switch (dataSeriesName) {
                    //    case "obsolete":
                    //        drillUrl = `/reports/slow-moving-items?reportTitle=Obsolete%20Inventory&autoFilterType=obsoleteinventory&previousPageUrl=/dashboard&previousPageTitle=Dashboard&${qs.stringify(params)}`;
                    //        break;
                    //    case "agedinventory":
                    //        drillUrl = `/reports/slow-moving-items?reportTitle=Aged%20Inventory&autoFilterType=agedinventory&previousPageUrl=/dashboard&previousPageTitle=Dashboard&${qs.stringify(params)}`;
                    //        break;
                    //    case "fastmoving":
                    //        // run the Top Seller Report, but by setting these parameters: (we want to form a 12 month date range)
                    //        // start date: selected month/year in dashboard MINUS 1 year PLUS 1 month, get the first day of this month
                    //        // end date: last day of selected month/year in dashboard

                    //        const startDate = moment(this.context.state.selectedFilterDate.dateID, "YYYYMM").subtract(1, 'year').add(1, 'month').startOf('month').format("YYYYMMDD");
                    //        const endDate = moment(this.context.state.selectedFilterDate.dateID, "YYYYMM").endOf('month').format("YYYYMMDD");

                    //        drillUrl = `/reports/top-seller-items?reportTitle=Fast%20Moving%20Inventory&autoFilterType=fastmoving&autoFilterStartDate=${startDate}&autoFilterEndDate=${endDate}&previousPageUrl=/dashboard&previousPageTitle=Dashboard&${qs.stringify(params)}`;
                    //        break;
                    //    default:
                    //        drillUrl = "";
                    //        break;
                    //}


                    // tooltip content: 
                    // - Name of data series
                    // - % value
                    // - $ value
                    // - "Click to drill down" (if a drilldown exists for this data series)
                    //const toolTipContent = `<div className='margin-bottom-10'><span style='\"'color: {color};'\"'>{name}</span> : ${result.percentValue}% (${formatMoney(result.dollarValue, currencyCode, languageCode)})</div> ${(!isEmpty(drillUrl) ? "Click to drill down" : "")}`;
                    const toolTipContent = `<div className='margin-bottom-10'><span style='"'color: {color};'"'>{name}</span> : ${result.percentValue}% (${formatMoney(result.dollarValue, currencyCode, languageCode)})</div>`;
                    result.toolTipContent = toolTipContent;
                    // result.toolTip = {
                    //     fontColor: "red"

                    // }


                });
                //console.log(dataSeriesName,results);



                // create a new dataSeries
                data.push({
                    type: "stackedBar100",
                    //color: series.color,
                    name: this.props.returnLocalizedString(this.parseCategory(series.category)),
                    //bevelEnabled: !isEmpty(drillUrl),
                    showInLegend: true,
                    indexLabel: "{y}", // displays additional info about a datapoint
                    indexLabelFontColor: "white",
                    yValueFormatString: "#,###'%'",
                    dataPoints: results,
                    //cursor: (isEmpty(drillUrl)) ? "" : "pointer",
                    //click: (e) => {
                    //    if (!isEmpty(drillUrl)) {
                    //        this.setState({ drillUrl });
                    //    }
                    //},
                    color: inventoryDataPointColorSet[index]
                });
            });
        }

        return {
            data: data,
            ...commonChartProps,
            height: 200,
            title: {
                text: this.props.returnLocalizedString("m0003"),
                ...chartTitleStyleParams
            },
            axisX: {
                title: "",
                lineColor: chartLineColor,
                gridColor: chartLineColor,
                tickColor: chartLineColor,
                labelFontFamily: chartFontFamily,
                labelFontSize: chartLabelFontSize,
                labelFontWeight: 500,
                labelFontColor: chartFontColor
            },
            axisY: {
                lineColor: chartLineColor,
                gridColor: chartLineColor,
                tickColor: chartLineColor,
                interlacedColor: "#F0F8FF",
                labelFontFamily: chartFontFamily,
                labelFontSize: chartLabelFontSize,
                labelFontWeight: 500,
                labelFontColor: chartFontColor
            }
        };
    };
    

    // pareto chart
    getYTDProfitComparisonChartParams = () => {
        const languageCode = this.props.uiLanguage;
        const { currencyCode } = this.context.state;
        //const { currencySymbol } = this.context.state;
        //var dps = [];
        var dataSeries = [];
        //var chart = this.ytdChart;

        //var yValue,
        //    yTotal = 0,
        //    yPercent = 0;

        if (
            this.state.ytdProfitData &&
            Object.keys(this.state.ytdProfitData).length > 0
        ) {
            // make deep copy of the ytd profit data, because we're going to modify some of the data
            let ytdProfitData = JSON.parse(
                JSON.stringify(this.state.ytdProfitData)
            );

            const months = ytdProfitData.dataSeriesRange;

            // render each data series
            ytdProfitData.dataSeriesLabel.forEach((series, index) => {
                // find the data points that match the category

                var results = ytdProfitData.data.filter(point => {
                    //console.log(point.category);
                    return point.category === series.category;
                });
                

                // rename properties in each data point
                results.forEach(result => {
                    delete result.category;
                    var date = new Date('1999, 12:00:00')
                    date.setMonth(months.findIndex((month) => month === result.month))
                    result.x = date;
                    //Object.defineProperty(
                    //    result,
                    //    "label",
                    //    Object.getOwnPropertyDescriptor(result, "month")
                    //);
                    //delete result.month;

                    Object.defineProperty(
                        result,
                        "y",
                        Object.getOwnPropertyDescriptor(result, "value")
                    );

                    if (result.value) {
                        const toolTipContent = `<span style='"'color: {color};'"'>{name}</span> : ${formatMoney(result.value, currencyCode, languageCode)}`;
                        result.toolTipContent = toolTipContent;
                    }
                    delete result.value;
                });

                var chartOptions = {};

                // make sure we render a line for the Growth % data series
                // for any other data series, just render a column bar
                if (series.category === "Growth %") {
                    chartOptions = {
                        type: "line",
                        axisYType: "secondary",
                        yValueFormatString: "####.00'%'"
                    };
                } else {
                    //switch (currencyCode) {
                    //    case "INR":
                    //        chartOptions = {
                    //            type: "column",
                    //            axisYType: "primary",
                    //            //yValueFormatString: `'${currencySymbol}'##,##,###,##,##,###.00`
                    //        };
                    //        break;
                    //    default:
                    //        chartOptions = {
                    //            type: "column",
                    //            axisYType: "primary",
                    //            //yValueFormatString: `'${currencySymbol}'###,###.00`
                    //        };
                    //        break;
                    //}
                    chartOptions = {
                        type: "column",
                        axisYType: "primary"
                    };
                }

                dataSeries.push({
                    name: this.parseSeriesName(series.category),
                    showInLegend: true,
                    dataPoints: results,
                    //indexLabelFormatter: function (e) {
                    //    //return CanvasJS.formatNumber(e.value, `'${currencySymbol}'###,###`);
                    //    return formatMoney(e.dataPoint.y, currencyCode, languageCode);
                    //},
                    color: profitDataPointColorSet[index],
                    //toolTipContent:
                    //    "<span style='\"'color: {color};'\"'>{name}</span> : {y}",
                    
                    ...chartOptions
                });
            });
        }

        return {
            data: dataSeries,
            theme: "light2",
            culture: this.props.getLanguage(),
            title: {
                text: this.props.returnLocalizedString("m0002"),
                ...chartTitleStyleParams
            },

            axisX: {
                title: "",
                lineColor: chartLineColor,
                gridColor: chartLineColor,
                tickColor: chartLineColor,
                labelFontFamily: chartFontFamily,
                labelFontSize: chartLabelFontSize,
                labelFontWeight: 500,
                labelFontColor: chartFontColor,
                valueFormatString:"MMM",
                interval: 2,
                intervalType: "month"

            },
            axisY: {
                lineColor: chartLineColor,
                gridColor: chartLineColor,
                tickColor: chartLineColor,
                interlacedColor: "#F0F8FF",
                labelFormatter: function (e) {
                    //return CanvasJS.formatNumber(e.value, `'${currencySymbol}'###,###`);
                    return formatMoney(e.value, currencyCode, languageCode);
                },
                labelFontFamily: chartFontFamily,
                labelFontSize: chartLabelFontSize,
                labelFontWeight: 500,
                labelFontColor: chartFontColor
            },
            axisY2: {
                suffix: "%",
                lineColor: "#C0504E",
                //tickColor: "white", // we want to hide the ticks
                tickThickness: 0,
                labelFontFamily: chartFontFamily,
                labelFontSize: chartLabelFontSize,
                labelFontWeight: 500,
                labelFontColor: chartFontColor
            },

            ...commonChartProps
        };
    };



    //!DBTRANS! @m0001@ Sales by product group !DEVNOTE! Chart caption
    //!DBTRANS! @m0002@ YTD gross profit comparison and growth !DEVNOTE! Chart caption
    //!DBTRANS! @m0003@ Inventory mix by turnover rate !DEVNOTE! Chart caption
    //!DBTRANS! @m0004@ Home !DEVNOTE! Header
    //!DBTRANS! @m0006@ Dashboard !DEVNOTE! Header
    //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
    //!DBTRANS! @m0128@ You need to specify a reporting period. !DEVNOTE! Action status reason
    //!DBTRANS! @m0129@ Unable to display KPI summary data. !DEVNOTE! Action status
    //!DBTRANS! @m0130@ Unable to display Inventory Mix data. !DEVNOTE! Action status
    //!DBTRANS! @m0131@ Unable to display YTD Gross Profit Comparison data. !DEVNOTE! Action status
    //!DBTRANS! @m0132@ Unable to display Sales by Product Group data. !DEVNOTE! Action status
    //!DBTRANS! @m0133@ Unable to retrieve dashboard data. Please try again. !DEVNOTE! Action status
    //!DBTRANS! @m0388@ Inventory Value !DEVNOTE! 
    //!DBTRANS! @m0389@ Total inventory value at the end of last full business day of selected month !DEVNOTE!
    //!DBTRANS! @m0390@ This Month Sales !DEVNOTE! 
    //!DBTRANS! @m0391@ Total sales revenue at the end of last full business day of selected month !DEVNOTE! 
    //!DBTRANS! @m0392@ This Month Gross Profit !DEVNOTE! 
    //!DBTRANS! @m0393@ Total gross profit of the selected month which is calculated by deducting Cost of Goods Sold from Total Sales Revenue of the selected month !DEVNOTE! 
    //!DBTRANS! @m0394@ Aged Inventory !DEVNOTE! 
    //!DBTRANS! @m0395@ Total inventory value of parts that didn't have any sales in past 12 months excluding obsolete parts and parts added to the catalog less than 12 months ago, as of end of the last full business day of selected month !DEVNOTE! 
    //!DBTRANS! @m0396@ Obsolete Inventory !DEVNOTE!                 
    //!DBTRANS! @m0397@ Inventory value of obsolete parts at the end of last full business day of selected month !DEVNOTE! 
    //!DBTRANS! @m0398@ YTD Gross Profit !DEVNOTE! 
    //!DBTRANS! @m0399@ Cumulative year to date gross profit at the end of last full business day of selected month !DEVNOTE! 
    //!DBTRANS! @m0400@ GMROI !DEVNOTE!
    //!DBTRANS! @m0401@ Gross Margin Return On Investment which is calculated by dividing Gross Margin by Average Inventory Cost. **NOTE: Average Inventory Cost is ideally calculated over 12 months period by dividing the sum of the Ending inventory value of each month by 12. When less than 12 months of inventory values is provided an estimated value is calculated. !DEVNOTE!
    //!DBTRANS! @m0402@ Inventory Turnover Rate !DEVNOTE! 
    //!DBTRANS! @m0403@ Inventory Turnover Rate is calculated by dividing Cost of Goods Sold by Average Inventory Cost. **NOTE: Average Inventory Cost is ideally calculated over 12 months period by dividing the sum of the Ending inventory value of each month by 12. When less than 12 months of inventory values is provided an estimated value is calculated. !DEVNOTE! 
    //!DBTRANS! @m0540@ Profit !DEVNOTE! Series Title
    //!DBTRANS! @m0535@ Aged Inventory !DEVNOTE! Graph data label
    //!DBTRANS! @m0536@ Obsolete !DEVNOTE! 
    //!DBTRANS! @m0537@ Slow Moving !DEVNOTE! 
    //!DBTRANS! @m0538@ Average Moving !DEVNOTE! 
    //!DBTRANS! @m0539@ Fast Moving !DEVNOTE! 
    //!DBTRANS! @m0544@ Growth !DEVNOTE! 
    //!DBTRANS! @m0545@ Select Part !DEVNOTE! 
    render() {


        //const orgType = this.context.state.orgType;


        if (!isEmpty(this.state.drillUrl)) {
            return <Redirect to={this.state.drillUrl} />;
        }

        const tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")}></Tab>
        </Tabs>);

        return (
            <AppContext.Consumer>
                {context => (
                    <div className="dashboard">
                        <div>
                            <Header title={this.props.returnLocalizedString("m0006")} tabs={tabs} />
                        </div>
                        <div className="dashboard-container">
                            <DashboardFilters
                                applyDashboardFilters={this.applyDashboardFilters}
                            />

                            <div style={{ width: "100%" }}>

                                <div>
                                    <div className="row">
                                        {this.state.kpiData &&
                                            <div className="col-md-12">
                                                <div className="grid">
                                                    <CardGrid
                                                        type="kpis"
                                                        data={
                                                            this.state.kpiData
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        }
                                        {this.state.inventoryData &&
                                            <div className="col-md-12 bottom-margin-20">

                                                <CanvasJSChartContainer

                                                    data={this.state.inventoryData}
                                                    title={"m0003"}
                                                    options={this.getInventoryChartParams()}
                                                    onRef={ref =>
                                                        (this.inventoryChart = ref)
                                                    }
                                                />

                                            </div>
                                        }
                                    </div>

                                    <div className="row">

                                        {this.state.ytdProfitData && this.state.productSalesData &&
                                            <React.Fragment>
                                                <div className="col-md-8">
                                                    <CanvasJSChartContainer
                                                        data={this.state.ytdProfitData}
                                                        title={"m0002"}
                                                        options={this.getYTDProfitComparisonChartParams()}
                                                        onRef={ref =>
                                                            (this.ytdChart = ref)
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-4 top-margin-sm-20">
                                                    <CanvasJSChartContainer

                                                        data={this.state.productSalesData}
                                                        title={"m0001"}
                                                        options={this.getSalesByProductGroupChartParams()}
                                                        onRef={ref =>
                                                            (this.salesByProductGroupChart = ref)
                                                        }
                                                    />


                                                </div>
                                            </React.Fragment>
                                        }



                                    </div>
                                </div>
                                {/*)}*/}
                            </div>
                        </div>
                    </div>
                )}
            </AppContext.Consumer>
        );
    }
}
//export default isPage(Dashboard);
export default isPage(Dashboard);

Dashboard.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js